import { render } from "./VarietiesTreeSelector.vue?vue&type=template&id=571180da&scoped=true&ts=true&lang=pug"
import script from "./VarietiesTreeSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./VarietiesTreeSelector.vue?vue&type=script&lang=ts&setup=true"

import "./VarietiesTreeSelector.vue?vue&type=style&index=0&id=571180da&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571180da"]])

export default __exports__